module.exports = __webpack_public_path__ + "static/media/verify21-new.a30b267c.png";